module.exports = __webpack_public_path__ + "assets/3e3a8fb5f56d6108e27c1e06a01cc628.png";